import { toQueryParamsString } from 'src/utils/ApiUtils';
import { CreateCustomerOptions } from 'src/interfaces/api/Customer';

import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getAll: (name, page = 1, limit = 10): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/customers${toQueryParamsString({ name, page, limit })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  create: (customer: CreateCustomerOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/customers`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(customer),
    credentials: 'include',
    method: 'POST',
  }),
};
